import React from 'react'
import { GatsbyImage } from 'gatsby-plugin-image'
import * as styles from './index.module.css'
import { GradientBorder } from '../commons'
import Button from '../Button/'
import Link from '../Link'

const LogoCollection = ({ components }) => {
  return (
    <div className="wrapper">
      <div className={styles.container}>
        <div className={styles.imageContainer}>
          {components.map((image, idx) =>
            image.ctaUrl != null && image.ctaUrl.length > 0 ? (
              <Link className={styles.singleImage} to={image.ctaUrl} key={idx}>
                <div className={styles.spacer}></div>
                <GatsbyImage
                  image={image.image.gatsbyImageData}
                  className={styles.image}
                  imgStyle={{ objectFit: 'contain' }}
                  alt={image.image.description}
                />
              </Link>
            ) : (
              <div className={styles.singleImage} key={idx}>
                <div className={styles.spacer}></div>
                <GatsbyImage
                  image={image.image.gatsbyImageData}
                  className={styles.image}
                  imgStyle={{ objectFit: 'contain' }}
                  alt={image.image.description}
                />
              </div>
            )
          )}
        </div>
      </div>
    </div>
  )
}

export default LogoCollection
